import { render } from "./Observacion.vue?vue&type=template&id=f9399b2a&scoped=true"
import script from "./Observacion.vue?vue&type=script&lang=js"
export * from "./Observacion.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=f9399b2a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9399b2a"]])

export default __exports__